export const de = {
    translation: {
        app: {
            error: {
                title: 'Hoppla! Hier stimmt etwas nicht...',
                event: 'Event: {{event}}',
                goBack: 'Zurück',
            },
        },
        components: {
            amountModifierInput: {
                plus: 'Plus',
                minus: 'Minus',
                set: 'Als Betrag',
                percentage: 'Prozent',
            },
            control: {
                dateInput: {
                    invalidDateFormat: 'Ungültiges Datumsformat',
                    dateBeforeMinDate: 'Das Datum liegt vor dem zulässigen Mindestdatum',
                    dateAfterMaxDate: 'Das Datum liegt nach dem zulässigen Höchstdatum',
                },
                phoneInput: {
                    invalidPhoneNumber: 'Ungültige Telefonnummer für das gewählte Land',
                },
                searchInput: {
                    placeholder: 'Suchen',
                },
                combobox: {
                    createOption: '{{query}} hinzufügen',
                    noOptions: 'Es konnten keine Optionen gefunden werden',
                    moreOptions: 'Weitere Optionen sind verfügbar — bitte nutzen Sie die Suche',
                    minQueryLength: 'Geben Sie mindestens {{length}} Zeichen ein',
                    loading: 'Wird geladen …',
                },
                textAreaTags: {
                    sample: 'Beispiel',
                    placeholder: 'Platzhalter',
                },
            },
            emptyState: {
                noAccess: {
                    title: 'Kein Zugriff',
                    subtitle: 'Sie haben keinen Zugriff auf diese Aktion',
                },
            },
            fileUpload: {
                tooBig: {
                    title: 'Einige Datei(en) sind zu groß',
                    message: 'Eine oder mehrere Dateien überschreiten die erlaubte Maximalgröße von {{maxSize}}',
                },
                uploadTitle: 'Wird hochgeladen',
                dropFilesTitle: 'Datei(en) ablegen',
                dropHereTitle: 'Dateien hier ablegen oder',
                selectFiles: 'hier klicken, um diese manuell auszuwählen',
                format: 'Format',
                size: 'Größe',
            },
            dialog: {
                confirm: {
                    prefix: 'Bitte bestätigen Sie, indem Sie Folgendes eingeben',
                    suffix: ':',
                },
            },
            pagination: {
                previousPage: 'Vorherige Seite',
                nextPage: 'Nächste Seite',
                show: 'Zeige {{fromCount, int}} bis {{toCount, int}}',
                total: 'von {{count, int}} insgesamt',
            },
            storageResourceSelect: {
                image: 'Bild',
                file: 'Datei',
                select: '{{type}} auswählen',
                change: '{{type}} ändern',
                clear: '{{type}} entfernen',
            },
            useSelectFile: {
                tooBig: {
                    title: 'Einige Datei(en) sind zu groß',
                    message: 'Eine oder mehrere Dateien überschreiten die maximal erlaubte Größe von {{maxSize}}',
                },
            },
        },
        routes: {
            errorPage: {
                goBack: 'Zurück',
            },
        },
    },
}
